import { inject } from '@angular/core';
import { CanActivateFn,Router } from '@angular/router';

/** Keeps signed-in users away from the login / sign-up pages. */
export const loginGuard: CanActivateFn = () =>
  localStorage.getItem('token') ? inject(Router).createUrlTree(['/pages']) : true;
